import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import { localeStringActions } from 'actions/api/localeStrings';
import MaterialTextField from 'components/util/materialTextField';
import { debounce } from 'lodash';
import LodIcon from 'components/util/lodIcon';
import MaterialSelect from 'components/util/materialSelect';
import Pagination from 'components/pagination';
import classnames from 'classnames';

class ManageTranslations extends Component {
  constructor(props) {
    super(props);
    this.languageOptions = this.generateLanguageOptions();
    this.state = {
      page: 1,
      searchString: '',
      languageSelection: this.languageOptions[0].value,
      verifiedState: null
    };
  }

  componentWillMount() {
    this.searchStrings();
  }

  searchStrings = () => {
    this.props.dispatch(
      localeStringActions.search({
        data: {
          language_id: this.state.languageSelection,
          verified: this.state.verifiedState,
          meta: {
            pagination: { page: this.state.page },
            text_search: this.state.searchString.trim() || null,
            sort: [{ order_by: 'base_string_id', order_type: 'DESC' }]
          }
        }
      })
    );
  };

  generateLanguageOptions = () => {
    let options = [];
    this.props.languages
      .sort((a, b) => a.title_english.localeCompare(b.title_english))
      .forEach(language => {
        options.push({
          label: language.title_english,
          value: language.id,
          icon: (
            <div
              style={{
                backgroundSize: 'contain',
                backgroundPosition: '50%',
                backgroundRepeat: 'no-repeat',
                width: 34,
                height: 26,
                verticalAlign: 'middle'
              }}
              className={`img-thumbnail flag flag-icon-background flag-icon-${
                language.alpha2
              }`}
            />
          )
        });
      });

    return options;
  };

  debouncedSearch = debounce(this.searchStrings, 300);

  onSearchChange = ({ target }) => {
    this.setState({ searchString: target.value, page: 1 });

    setTimeout(this.debouncedSearch);
  };

  onPageChange = page => {
    this.setState({ page });
    setTimeout(this.searchStrings);
  };

  onLanguageChange = value => {
    this.setState({ languageSelection: value, page: 1, searchString: '' });

    setTimeout(this.searchStrings);
  };

  changeTab = tab => {
    this.setState({ verifiedState: tab, searchString: '', page: 1 });

    setTimeout(this.searchStrings);
  };

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div>Manage Translations</div>
          <div className={styles.search}>
            <LodIcon icon="search" />
            <div className={styles.searchInput}>
              <MaterialTextField
                value={this.state.searchString}
                onChange={this.onSearchChange}
                hintText="Search by key or english value"
              />
            </div>
          </div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader}>
            <div className={styles.languageSelect}>
              <MaterialSelect
                options={this.languageOptions}
                value={this.state.languageSelection}
                onChange={this.onLanguageChange}
                autoWidth
              />
            </div>
            <div className={styles.pagination}>
              <Pagination
                pagination={this.props.pagination}
                onChange={this.onPageChange}
              />
            </div>
            <div className={styles.tabs}>
              <div
                onClick={() => this.changeTab(null)}
                className={classnames(styles.tab, {
                  [styles.active]: this.state.verifiedState === null
                })}>
                All
              </div>
              <div
                onClick={() => this.changeTab(false)}
                className={classnames(styles.tab, {
                  [styles.active]: this.state.verifiedState === false
                })}>
                Unverified
              </div>
              <div
                onClick={() => this.changeTab(true)}
                className={classnames(styles.tab, {
                  [styles.active]: this.state.verifiedState === true
                })}>
                Verified
              </div>
            </div>
          </div>
          <div className={styles.tableWrapper}>
            <div className={styles.headerWrapper}>
              <table>
                <colgroup>
                  <col width="10%" />
                  <col width="30%" />
                  <col width="30%" />
                  <col width="30%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>English</th>
                    <th>Google Translation</th>
                    <th>Verified Translation</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles.bodyWrapper}>
              <table>
                <colgroup>
                  <col width="10%" />
                  <col width="30%" />
                  <col width="30%" />
                  <col width="30%" />
                </colgroup>
                <tbody>
                  {this.props.localeStrings
                    .sort(
                      (a, b) =>
                        +new Date(b.base_string.created_at) -
                        +new Date(a.base_string.created_at)
                    )
                    .map(string => {
                      return (
                        <tr key={string.id}>
                          <td className={styles.keyCell}>
                            {string.base_string.key}
                          </td>
                          <td>{string.base_string.value}</td>
                          <td>{string.google_translation}</td>
                          <td>{string.partner_translation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    localeStrings: state.localeStrings.list,
    pagination: state.localeStrings.meta.pagination,
    languages: state.languages.list
  };
})(ManageTranslations);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/manageTranslations/index.js